import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiResponse } from "@/shared/types/api";
import { useSession } from "@/auth/contexts/auth-context";

import { QUERY_KEYS } from "@/users/api/config";
import {
  getAllUsers,
  IGetUsersResponse,
  inviteUser,
  IInviteUser,
} from "@/users/api/requests/user.requests";

export const useGetAllUsers = () => {
  const { accessToken, isLoading: authLoading } = useSession();

  return useQuery<ApiResponse<IGetUsersResponse[]>>({
    queryKey: [QUERY_KEYS.USER],
    queryFn: () => getAllUsers(),
    enabled: true,
    // enabled: !!accessToken && !authLoading,
  });
};

export const useInviteUser = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<any>, Error, IInviteUser>({
    mutationFn: (data) => inviteUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INVITE] });
    },
  });
}